export class Translation {
    label: string;
    path?: string;
    isModified: boolean;
    english?: string | null;
    spanish?: string | null;
    chinese?: string | null;
    children?: Translation[] | null;
}
